import React from "react";
import ReactDOM from "react-dom";

import { Radio } from "../../../vendor";
import { Biscuit, Uri } from "../../utils";
import t from "../helpers/t";

import DemoOrdersPage from "../pages/DemoOrdersPage";
import { FileManagerPage } from "../pages/fileManager";
import { OpeningTimesPage } from "../pages/openingTimes";
import { ProductsPage } from "../pages/products";
import { ResourcesPage } from "../pages/resources";
import { PricetariffsPage } from "../pages/pricetariffs";
import { AvailabilitiesPage } from "../pages/availabilities";

import { TasksPage } from "../pages/tasks";
import { FacilityPage } from "../pages/facilities";
import { UsersPage } from "../pages/users";
import { FrontendLocationsPage } from "../pages/frontend_locations";
import { DashboardPage } from "../pages/dashboard";
import { LocationsPage } from "../pages/locations";
import { FinancesPage } from "../pages/finances";
import { StatisticsPage } from "../pages/statistics";
import Notifications from "../helpers/Notifications";
import { ReservationsPage } from "../pages/reservations";
import { getAllUrlParams } from "../../utils";
import { ErrorsPage } from "../pages/errors";
import { SettingsPage } from "../pages/client_settings";
import { VouchersPage } from "../pages/vouchers";
import { HelpdeskPage } from "../pages/helpdesk";
import { InvoicesPage } from "../pages/invoices";
//import { ContingentPlansPage } from '../pages/contingents/contingentPlans';
import { ContingentsPage } from "../pages/contingents";
import { MyInboomaPage } from "../pages/myInbooma";
import { VisualInspectionsPage } from "../pages/visual_inspections";
import { AbonnementsPage } from "../pages/abonnements";
import { ReportsPage } from "../pages/reports";

import {
  configureStore,
  fileManagerActions,
  fileManagerSelectors,
  productsActions,
  contingentsActions,
  locationActions,
  connect,
  apiSettings,
  priceTariffsActions,
  frontendLocationsActions,
} from "inbooma-api";
import { Provider } from "../helpers/AppProviders";
import InboomaBaseController from "../../controllers/InboomaBaseController";
import { getApiHost } from "../../Sync";
import { containsNumbers, getItem } from "../../utils/Helper";
import { ClientDocumentsPage } from "../pages/client_documents";
import { HelpMessagesPage } from "../pages/helpMessages";

let store = null;

export default InboomaBaseController.extend({
  _el: "#inb-c",

  initialize() {
    this._resetOptions(this.options);

    const apiHost = getApiHost();

    document.getElementById("inb-c").classList.add("inb-react-view-container");

    apiSettings.setSettings({
      apiEntryPoint: getApiHost() + (!apiHost.endsWith("/") ? "/" : ""),
    });
  },

  /**
   * Observes router state to unmount previous set react components.
   *
   * @todo Ideally we should also provide some "on requests failed" bootstrapping functionality,
   * redirecting invalid token users to the login-form as done in App.js
   */
  onBeforeRenderComponent() {
    if (store === null) {
      // First time controller was called
      store = configureStore();
      console.log("store configured, start websocket");
      // @ToDo: decomment the following line to reactivate websocket
      //   websocket(store);
    }

    document.querySelector(".js-off-canvas-overlay").classList.remove("is-visible");

    const that = this,
      app = Radio.channel("app"),
      onRouterExecute = function (from, to) {
        if (to.controllerName !== "reactController") {
          // Free memory by unmounting active component(s)
          ReactDOM.unmountComponentAtNode(document.querySelector(that.el)); // .el.lastChild;?
        }

        app.off("router:execute", onRouterExecute);
      };

    app.on("router:execute", onRouterExecute);
    return this;
  },

  /**
   * FOR DEMO PURPOSE ONLY:
   * Shows a list of orders (typeof Backbone.Collection) by
   * implementing InboomaReactModelView. Updating a model attribute
   * will trigger a re-render on the React view (and, if you want to, vice versa)
   */
  index() {
    this.onBeforeRenderComponent();

    const orders = Radio.channel("orders").request("get:data");

    console.log("Orders-Collection: Update a model and see it become re-rendered", orders);

    ReactDOM.render(<DemoOrdersPage orders={orders.models} />, document.querySelector(this.el));
  },

  /**
   * @param {String} uriParams e.g. 'opening_times?location_id=646'
   */
  openingTimesIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-c-main-access-bar");
    let createAccessBar = false;

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    } else {
      createAccessBar = true;
    }

    ReactDOM.render(
      <Provider store={store}>
        <OpeningTimesPage createAccessBar={createAccessBar} />
      </Provider>,
      document.querySelector(this.el),
    );

    store.dispatch({
      type: "CITIES",
      link: "locations?find=short&limit=999&page=1&sort=name&direction=asc",
      token: Biscuit.get("token"),
    });

    store.dispatch({
      type: "PRICES",
      link: "pricetariffs?find=short&limit=999&page=1&sort=name&direction=asc",
      token: Biscuit.get("token"),
    });

    if (uriParams) {
      // Pre-filter selected location
      const params = uriParams.split("=");

      if (typeof params[1] !== "undefined") {
        setTimeout(() => {
          store.dispatch({
            type: "PERIODS",
            link: `check_in_periods?location_id=${params[1]}&sort=valid_from&direction=asc`,
            token: Biscuit.get("token"),
          });
        }, 200); // use a timeout to ensure overriding of recent collection data (bugfix [#25066])

        // Mark for pre-selection in LocationsDropdown
        window.__temp_filter_location_id = params[1];

        store.dispatch({ type: "CLEAR_NEW_PERIODS" });
        store.dispatch({ type: "CLEAR_PATCHES" });
      }
    }

    if (accessBar) {
      accessBar = document
        .getElementById("inb-c-main")
        .insertAdjacentElement("afterbegin", accessBar);
      if (accessBar.querySelector(".active") != null)
        accessBar.querySelector(".active").classList.remove("active");
      accessBar.querySelector('li[data-inb-val="all_times"]').classList.add("active");
    }
  },

  fileManagerIndex() {
    this.onBeforeRenderComponent();

    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-c-main-access-bar");

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    }

    // Initial fetch
    store.dispatch(
      fileManagerActions.getFolders({
        token: Biscuit.get("token"),
      }),
    );

    store.dispatch(
      fileManagerActions.getTags({
        namespace: "UserDoc",
        token: Biscuit.get("token"),
      }),
    );

    store.dispatch(
      locationActions.getLocations({
        token: Biscuit.get("token"),
        filter: {
          find: "short",
          limit: "999",
          sort: "name",
          sortDirection: "asc",
        },
      }),
    );

    const mapFileManagerStateToProps = (state) => {
      return {
        docs: state.fileManager.documents.data,
        folders: fileManagerSelectors.mapFoldersToTree(state.fileManager.folders.data),
        foldersFetchSuccess: !state.fileManager.folders.loading,
        tags: state.fileManager.tags.data,
        locations: state.locations_data.locations.data,
      };
    };

    const mapNotificationsStateToProps = (state) => {
      return {
        alerts: state.alerts_data.alerts.data,
      };
    };

    const MyFileManagerPage = connect(mapFileManagerStateToProps)(FileManagerPage);
    const MyNotifications = connect(mapNotificationsStateToProps)(Notifications);

    ReactDOM.render(
      <Provider store={store}>
        <MyFileManagerPage />
        <MyNotifications />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  productsIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-c-main-access-bar");
    let createAccessBar = false;

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    } else {
      createAccessBar = true;
    }
    let language = Biscuit.get("user.lang").replace("_", "-");
    apiSettings.setSettings({
      apiLanguage: language,
    });
    const status = {
      contingents: "pending",
      products: "pending",
      product: "none",
      product_id: null,
      complete: false,
      complete2: false,
    };
    // Initial fetch
    store.dispatch(
      productsActions.getProducts({
        token: Biscuit.get("token"),
        filter: {
          sort: "sort_order",
          limit: 100,
          page: 1,
          direction: "asc",
        },
        parameters: {
          headers: {
            "Accept-Language": language,
          },
        },
      }),
    );

    store.dispatch(
      contingentsActions.getContingents({
        token: Biscuit.get("token"),
        filter: {
          findForSelect: true,
          limit: 1000,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    let params = null;
    if (uriParams) {
      // set selected task
      params = uriParams.split("=");
      if (typeof params[0] !== "undefined") {
        if (params[0] !== "add") {
          store.dispatch(
            productsActions.getProduct({
              id: Number(params[0]),
              token: Biscuit.get("token"),
            }),
          );
          status.product_id = Number(params[0]);
          status.product = "pending";
        } else if (params[0] === "add") {
          status.product = "add";
        }
      }
    }

    // update and return new status
    const getStatus = (state) => {
      if (status.products == "pending" && state.products_data.products.success === true)
        status.products = "finished";
      if (status.product == "pending" && state.products_data.product.success === true)
        status.product = "finished";
      if (status.contingents == "pending" && state.contingents_data.contingents.success === true)
        status.contingents = "finished";

      if (
        !status.complete &&
        status.products == "finished" &&
        (status.product == "finished" || status.product == "add" || status.product == "none") &&
        status.contingents == "finished"
      ) {
        status.complete = true;
      }
      return status;
    };

    const mapProductStateToProps = (state) => {
      const cn = () => {
        let data = state.contingents_data.contingents.data;
        if (getItem("contingent", true) !== null) {
          let contingent = getItem("contingent", true);
          if (typeof contingent.id === "undefined" || contingent.id === null) {
            let hasId = false;
            data.map((dat) => {
              if (dat.id === null) {
                hasId = true;
              }
            });
            if (!hasId) data.push({ id: null, name: contingent.name });
          }
        }
        return data;
      };
      return {
        products: state.products_data.products.data,
        product: state.products_data.product.data,
        contingents: cn(),
        productsFetchSuccess: state.products_data.products.actionState === "GET_PRODUCTS_SUCCESS",
        status: getStatus(state),
        createAccessBar: createAccessBar,
      };
    };

    const mapNotificationsStateToProps = (state) => {
      return {
        alerts: state.alerts_data.alerts.data,
      };
    };

    const MyProductsPage = connect(mapProductStateToProps)(ProductsPage);
    const MyNotifications = connect(mapNotificationsStateToProps)(Notifications);

    ReactDOM.render(
      <Provider store={store}>
        <MyProductsPage params={params} />
        <MyNotifications />
      </Provider>,
      document.querySelector(this.el),
    );

    if (accessBar) {
      accessBar = document
        .getElementById("inb-c-main")
        .insertAdjacentElement("afterbegin", accessBar);
      if (accessBar.querySelector(".active") != null)
        accessBar.querySelector(".active").classList.remove("active");
      accessBar.querySelector('li[data-inb-val="products"]').classList.add("active");
    }
  },

  taskIndex(uriParams = null, uriParams2 = null, uriParams3 = null) {
    this.onBeforeRenderComponent();

    // get view to render
    let view = "tasks";
    let subParams = {
      returnPath: Uri.getUrlParameter("path"),
      fk_model: Uri.getUrlParameter("fk_model"),
      fk_id: Uri.getUrlParameter("fk_id"),
      lead: Uri.getUrlParameter("lead"),
      id: null,
      add: false,
      resId: null,
      assignee: null,
    };
    const allUrlParams = getAllUrlParams(window.location.href);
    if (uriParams) {
      // set selected location
      const params = uriParams.split("=");
      if (typeof params[0] !== "undefined") {
        if (!isNaN(params[0])) {
          subParams["id"] = params[0];
        } else if (params[0] === "id") {
          subParams["resId"] = params[1];
        } else if (params[0] === "assignee") {
          subParams["assignee"] = params[1];
        } else if (params[0] === "add") {
          subParams["add"] = true;
        } else {
          subParams[params[0]] = params[1];
        }
      }
    }
    Object.keys(allUrlParams).map((param) => {
      subParams[param] = allUrlParams[param];
    });

    const mapTasksStateToProps = (state) => {
      return {
        view: view,
      };
    };

    const InbTasksPage = connect(mapTasksStateToProps)(TasksPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbTasksPage params={subParams} />
      </Provider>,
      document.querySelector(this.el),
    );

    let mainMenu = document.getElementById("inb-main-menu");
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector(".active")) {
      mainMenu.querySelector(".active").classList.remove("active");
    }

    /* // hide accessbar if exist - task modul has no accessbar
        let accessBar = document.getElementById('inb-c-main-access-bar');
        if (accessBar !== undefined && accessBar != null) accessBar.className += " hide";

        // unmark active main tab if one is active
        let mainMenu = document.getElementById('inb-main-menu');
        if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.active')) {
            mainMenu.querySelector('.active').classList.remove('active');
        }
        let language = Biscuit.get('user.lang').replace('-','_');
        apiSettings.setSettings({
            apiLanguage: language
        });
        const store = configureStore();
        // status is used to get control about request state
        const status = {
            tasks: 'pending',
            task: 'none',
            returnPath: Uri.getUrlParameter('path'),
            fk_model: Uri.getUrlParameter('fk_model'),
            fk_id: Uri.getUrlParameter('fk_id'),
            lead: Uri.getUrlParameter('lead'),
            complete: false
        };

        const pagination = {
            limit: 50,
            page: 1,
        }

        store.dispatch(taskActions.getTasks({
            token: Biscuit.get('token'),
            filter: {
                'find' : '!Done',
                'limit' : pagination.limit,
                'page' : pagination.page,
                'sort' : 'created',
                'direction' : 'desc'
            },
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));

        if (uriParams) {
            // set selected task
            const params = uriParams.split('=');

            if (typeof params[0] !== 'undefined') {
                if (params[0] !== 'add') {
                    store.dispatch(taskActions.getTask({
                        id: Number(params[0]),
                        token: Biscuit.get('token'),
                        parameters: {
                            headers: {
                                "Accept-Language": language
                            }
                        }
                    }));
                    status.task = 'pending';
                } else if (params[0] == 'add') {
                    status.task = 'add';
                }
            }
        }

        // update and return new status
        const getStatus = (state) => {
            if (status.tasks == 'pending' && state.tasks.tasks.success === true) status.tasks = 'finished';
            if (status.task == 'pending' && state.tasks.task.success === true) status.task = 'finished';
            if (!status.complete && status.tasks == 'finished' &&
                (status.task == 'finished' || status.task == 'add' || status.task == 'none'))
                {
                    status.complete = true;
                }
            return status;
        };

        const mapTaskStateToProps = (state) => {
            return {
                tasks: state.tasks,
                pagination: {...state.tasks.tasks.pagination,limit: pagination.limit},     // get limit from pagination settings because it is not part of the api response
                resources: state.resources_data.getResources,
                facilities: state.facilities,
                task: state.tasks.task,
                status: getStatus(state)
            }
        };

        const MyTasks = connect(mapTaskStateToProps)(TaskList);

                   ReactDOM.render(
                       <Provider store={store}>
                            <MyTasks />
                        </Provider>,
                   document.querySelector(this.el)
            );*/
  },

  facilityIndex(uriParams = null, uriParams2) {
    this.onBeforeRenderComponent();

    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-c-main-access-bar");
    let createAccessBar = false;

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    } else {
      createAccessBar = true;
    }
    const view = "facilities";
    let subParams = {
      returnPath: Uri.getUrlParameter("path"),
      id: null,
      facilityId: null,
      facilitySlotId: null,
      addFacilitySlot: false,
      add: false,
      edit: false,
    };
    if (uriParams) {
      // set selected location
      const params = uriParams.split("=");
      if (typeof params[0] !== "undefined" && params[0] !== "") {
        if (!isNaN(params[0])) {
          subParams["id"] = params[0];
          subParams["edit"] = true;
        } else if (params[0] === "id") {
          subParams["facilityId"] = params[1];
        } else if (params[0] === "add") {
          subParams["add"] = true;
        } else {
          subParams[params[0]] = params[1];
        }
      }
    }
    if (uriParams2) {
      const params = uriParams2.split("=");
      if (typeof params[0] !== "undefined" && params[0] !== "") {
        if (!isNaN(params[0])) {
          subParams["facilitySlotId"] = params[0];
          subParams["edit"] = false;
        } else if (params[0] === "add") {
          subParams["addFacilitySlot"] = true;
          subParams["edit"] = false;
        }
      }
    }

    const mapFacilityStateToProps = (state) => {
      return {
        createAccessBar: createAccessBar,
        view: view,
      };
    };

    const MyFacilities = connect(mapFacilityStateToProps)(FacilityPage);

    ReactDOM.render(
      <Provider store={store}>
        <MyFacilities params={subParams} />
      </Provider>,
      document.querySelector(this.el),
    );

    if (accessBar) {
      accessBar = document
        .getElementById("inb-c-main")
        .insertAdjacentElement("afterbegin", accessBar);
      if (accessBar.querySelector(".active") != null)
        accessBar.querySelector(".active").classList.remove("active");
      accessBar.querySelector('li[data-inb-val="facilities"]').classList.add("active");

      // hide contingents searchbar
      if (document.getElementById("inb-c-main-access-bar__search") != null) {
        document.getElementById("inb-c-main-access-bar__search").classList.add("hide");
      }
    }
  },

  pricetariffsIndex(uriParams = null, uriParams2 = null, uriParams3 = null) {
    this.onBeforeRenderComponent();
    let language = Biscuit.get("user.lang");
    apiSettings.setSettings({
      apiLanguage: language,
    });
    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-c-main-access-bar");
    let createAccessBar = false;

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    } else {
      createAccessBar = true;
    }

    const store = configureStore();

    const status = {
      pricetariffs: "pending",
      pricetariff: "none",
      pricetariffValidFrom: "none",
      contingents: "pending",
      products: "pending",
      pricetypes: "pending",
      product_id: null,
      complete: false,
      complete2: false,
    };
    // Initial fetch
    /*    store.dispatch(priceTariffsActions.getPricetariffs({
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        })); */
    let uParams = {
      pricetariffId: null,
      pricetariffValidFromId: null,
      productId: null,
      add: false,
    };
    const view = "pricetariffs";
    console.log(uriParams2);
    if (uriParams) {
      // set selected resource
      const params = uriParams.split("/");
      let params2, params3;
      if (uriParams2 !== null) {
        params2 = uriParams2.split("_");
      }
      if (uriParams3 !== null) {
        params3 = uriParams3.split("_");
      }
      if (typeof params[0] !== "undefined") {
        console.log(params[0], "params[0]");
        if (params[0] !== "add") {
          if (uriParams2 === "add" && uriParams2 !== null) {
            console.log("inside?");
            console.log(params[0]);
            store.dispatch(
              priceTariffsActions.getPricetariff({
                id: Number(params[0]),
                token: Biscuit.get("token"),
                parameters: {
                  headers: {
                    "Accept-Language": language,
                  },
                },
              }),
            );
            uParams.pricetariffId = Number(params[0]);
            uParams.add = true;
          }
          if (uriParams2 !== null && uriParams2 !== "add") {
            uParams.pricetariffId = Number(params[0]);
            uParams.pricetariffValidFromId = Number(uriParams2);
            uParams.add = false;
          }
        } else if (params[0] === "add") {
          if (uriParams2 !== null) {
            uParams.productId = params2[1];
          }
          uParams.add = true;
        }
      }
    }

    /*   store.dispatch(pricetypesActions.getPricetypes({
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));

        store.dispatch(pricesActions.getPrices({
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));

        store.dispatch(productsActions.getProducts({
            token: Biscuit.get('token'),
            filter: {
                'findForSelect': true,
                'limit': 1000
            },
            parameters: {
                headers: {
                    "Accept-Language": language
                }
        }
        }));*/

    // update and return new status
    /*  const getStatus = (state) => {
            if (status.pricetariffs === 'pending' && state.price_tariffs_data.pricetariffs.actionState === 'GET_PRICETARIFFS_SUCCESS') status.pricetariffs = 'finished';
            if (status.pricetariff === 'pending' && state.price_tariffs_data.pricetariff.success === true){
                if (state.products_data.products.success === true){

                    status.pricetariff = 'finished';
                }
            }
            if (status.pricetariffValidFrom === 'pending' && state.price_tariff_valid_froms_data.pricetariffValidFrom.success === true){
               if(state.price_tariffs_data.pricetariff.success === true) {
                   status.pricetariffValidFrom = 'finished';
               }
            }
             if (status.products === 'pending' && state.products_data.products.success === true) status.products = 'finished';
            if (status.pricetypes === 'pending' && state.pricetypes_data.pricetypes.success === true) status.pricetypes = 'finished';
            if (!status.complete &&
                status.pricetariffs === 'finished' &&
                (status.pricetariff === 'finished' || status.pricetariff === 'add' || status.pricetariff === 'none') &&
                status.products === 'finished' &&
                status.pricetypes === 'finished') {
                status.complete = true;
                status.complete2 = false;
            }
            if (!status.complete2 &&
                status.pricetariffs === 'finished' &&
                status.pricetariff === 'finished' &&
                (status.pricetariffValidFrom === 'finished' || status.pricetariffValidFrom === 'add') &&
                status.pricetypes === 'finished') {
                status.complete2 = true;
                status.complete = false;
            }
            return status;
        };
*/

    const mapPricetariffStateToProps = (state) => {
      return {
        createAccessBar: createAccessBar,
        view: view,
      };
    };

    const MyPricetariffsPage = connect(mapPricetariffStateToProps)(PricetariffsPage);

    ReactDOM.render(
      <Provider store={store}>
        <MyPricetariffsPage params={uParams} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );

    if (accessBar) {
      accessBar = document
        .getElementById("inb-c-main")
        .insertAdjacentElement("afterbegin", accessBar);
      if (accessBar.querySelector(".active") != null)
        accessBar.querySelector(".active").classList.remove("active");
      accessBar.querySelector('li[data-inb-val="pricetariffs"]').classList.add("active");
    }
  },

  usersIndex(uriParams = null, uriParams2 = null, uriParams3 = null) {
    this.onBeforeRenderComponent();
    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-main-menu");

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    }
    let language = Biscuit.get("user.lang");
    apiSettings.setSettings({
      apiLanguage: language,
    });
    // const store = configureStore();
    let view = "index";
    const path = document.location.pathname;
    if (path.startsWith("/users")) view = "users";
    if (path.startsWith("/usersExtension/userGroups")) view = "usergroups";
    if (path.startsWith("/usersExtension/messages")) view = "messages";
    if (path.startsWith("/usersExtension/mailSettings")) view = "mailsettings";
    let action = "users";
    if (path.startsWith("/users/staff")) {
      action = "staff";
    }
    let userId = null;
    if (view === "users") {
      let sub = path.split("/users/");
      if (
        sub[0] !== "add" &&
        !sub[0].includes("users") &&
        !sub[0].includes("active") &&
        !sub[0].includes("role")
      ) {
        userId = sub[0];
      }
    }

    let add =
      path.startsWith("/usersExtension/mailSettings/add") ||
      path.startsWith("/usersExtension/messages/add") ||
      path.startsWith("/usersExtension/userGroups/add") ||
      path.startsWith("/users/add");
    let subParams = {
      returnPath: Uri.getUrlParameter("path"),
      id: null,
      userId: userId,
      messageId: null,
      membershipTypeId: null,
      mailSettingsId: null,
      add: add,
    };

    if (uriParams === "mailSettings") {
      uriParams = uriParams2;
    }
    if (uriParams) {
      // set selected location
      const params = uriParams.split("=");
      if (typeof params[0] !== "undefined") {
        if (!isNaN(params[0]) || userId !== null) {
          switch (view) {
            case "users":
              subParams.userId = params[0];
              break;
            case "usergroups":
              subParams.membershipTypeId = params[0];
              break;
            case "messages":
              subParams.messageId = params[0];
          }
        } else if (params[0] === "id") {
          if (view === "mailsettings") {
            console.log(typeof params[1]);
            if (typeof params[1] === "string" && params[1].includes("&path")) {
              let tmp = params[1].split("&path");
              params[1] = tmp[0];
              subParams.returnPath = params[3];
            }
            let setId = params[1];
            console.log("setId", setId);
            if (typeof setId === "undefined") {
              setId = Biscuit.get("user.id");
            }
            subParams.mailSettingsId = setId;
          } else {
            subParams[params[0]] = params[1];
          }
        } else if (params[0] === "add") {
          subParams["add"] = true;
        } else {
          subParams[params[0]] = params[1];
        }
      }
    }
    if (subParams.userId === "") {
      subParams.userId = null;
    }
    const mapUserStateToProps = (state) => {
      return {
        view: view,
      };
    };

    const mapNotificationsStateToProps = (state) => {
      return {
        alerts: state.alerts_data.alerts.data,
      };
    };

    const MyUsersPage = connect(mapUserStateToProps)(UsersPage);
    if (subParams.userId === "add" && subParams.add === true) {
      subParams.userId = null;
    }
    ReactDOM.render(
      <Provider store={store}>
        <MyUsersPage action={action} params={subParams} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );

    if (accessBar) {
      if (accessBar.querySelector(".active") != null)
        accessBar.querySelector(".active").classList.remove("active");
      accessBar.querySelector(".l-users").classList.add("active");
    }
  },

  frontendLocationsIndex(uriParams = null) {
    this.onBeforeRenderComponent();
    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-main-menu");

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    }

    const store = configureStore();

    const status = {
      frontendLocations: "none",
      frontendLocation: "none",
      jobs: "none",
      returnPath: Uri.getUrlParameter("path"),
      action: "getFrontendLocations",
      complete: false,
    };

    // Initial fetch
    /*
        store.dispatch(userActions.getUsers({
            token: Biscuit.get('token')
        }));
*/
    if (document.location.pathname.startsWith("/frontend_locations/jobs")) {
      // staff view - fetch staff
      store.dispatch(
        frontendLocationsActions.getJobs({
          token: Biscuit.get("token"),
        }),
      );
      status.jobs = "pending";
      status.action = "getJobs";
    } else {
      // users index
      store.dispatch(
        frontendLocationsActions.getFrontendLocations({
          token: Biscuit.get("token"),
        }),
      );
      status.frontendLocations = "pending";
      status.action = "getFrontendLocations";
    }

    if (uriParams) {
      // check for adding and editing user
      const params = uriParams.split("=");
      if (typeof params[0] !== "undefined" && params[0] !== "jobs") {
        // params should be user hash
        store.dispatch(
          frontendLocationsActions.getFrontendLocation({
            id: params[0],
            token: Biscuit.get("token"),
          }),
        );
        status.frontendLocation = "pending";
        status.action = "view";
      }
    }

    // update and return new status
    const getStatus = (state) => {
      if (
        status.frontendLocations === "pending" &&
        state.frontend_locations_data.frontendLocations.success === true
      )
        status.frontendLocations = "finished";
      if (
        status.frontendLocation === "pending" &&
        state.frontend_locations_data.frontendLocation === true
      )
        status.frontendLocation = "finished";
      if (
        status.jobs === "pending" &&
        (state.frontend_locations_data.getJobs.success === true ||
          state.frontend_locations_data.getJobs.success === false)
      )
        status.jobs = "finished";
      if (
        !status.complete &&
        (status.frontendLocations === "finished" || status.frontendLocations === "none") &&
        (status.frontendLocation === "finished" || status.frontendLocation === "none")
      ) {
        status.complete = true;
      }
      return status;
    };

    const mapFrontendLocationStateToProps = (state) => {
      return {
        frontendLocations: state.frontend_locations_data.frontendLocations.data,
        frontendLocation: state.frontend_locations_data.frontendLocation.data,
        jobs: state.frontend_locations_data.getJobs.data,
        push_changes: state.frontend_locations_data.pushChanges.data,
        frontendLocationsFetchSuccess:
          state.frontend_locations_data.frontendLocations.actionState ===
          "GET_FRONTEND_LOCATIONS_SUCCESS",
        status: getStatus(state),
      };
    };

    const mapNotificationsStateToProps = (state) => {
      return {
        alerts: state.alerts_data.alerts.data,
      };
    };

    const MyFrontendLocationsPage = connect(mapFrontendLocationStateToProps)(FrontendLocationsPage);
    const MyNotifications = connect(mapNotificationsStateToProps)(Notifications);

    ReactDOM.render(
      <Provider store={store}>
        <MyFrontendLocationsPage />
        <MyNotifications />
      </Provider>,
      document.querySelector(this.el),
    );

    if (accessBar) {
      accessBar = document
        .getElementById("inb-c-main")
        .insertAdjacentElement("afterbegin", accessBar);
      if (accessBar.querySelector(".active") != null)
        accessBar.querySelector(".active").classList.remove("active");
      accessBar.querySelector('li[data-inb-val="frontend_locations"]').classList.add("active");
      if (document.getElementById("inb-c-main-access-bar__search") != null) {
        document.getElementById("inb-c-main-access-bar__search").classList.add("hide");
      }
    }
  },

  dashboardIndex() {
    this.onBeforeRenderComponent();

    const mapDashboardStateToProps = (state) => {
      return {
        user: state.users_data.user.data,
      };
    };

    const MyDashboardPage = connect(mapDashboardStateToProps)(DashboardPage);

    ReactDOM.render(
      <Provider store={store}>
        <MyDashboardPage />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  locationsIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-c-main-access-bar");
    let createAccessBar = false;

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    } else {
      createAccessBar = true;
    }
    createAccessBar = true; // quick fix to always draw the access bar

    const status = {
      returnPath: Uri.getUrlParameter("path"),
      action: "none",
      location_id: null,
    };

    if (uriParams) {
      // set selected location
      const params = uriParams.split("=");

      if (typeof params[0] !== "undefined") {
        if (params[0] !== "add" && !Number.isNaN(params[0])) {
          if (Uri.getUrlParameter("action") == "delete") {
            status.action = "delete";
            if (confirm(t("delete_${a}", { a: t("location_") }) + "?")) {
              store.dispatch(
                locationActions.deleteLocation({
                  token: Biscuit.get("token"),
                  location_id: params[0],
                  parameters: {
                    headers: {
                      "Accept-Language": Biscuit.get("user.lang").replace("-", "_"),
                    },
                  },
                }),
              );
              var index = document.location.href.indexOf("locations");
              setTimeout(() => {
                document.location.href = document.location.href.substring(0, index + 9);
              }, 500);
              //return;
            } else {
              var index = document.location.href.indexOf("locations");
              document.location.href = document.location.href.substring(0, index + 9);
              //return;
            }
            return;
          } else {
            status.action = "edit";
          }
          status.location_id = params[0];
        } else if (params[0] == "add") {
          status.action = "add";
        }
      }
    }
    const mapLocationsStateToProps = () => {
      return {
        createAccessBar: createAccessBar,
        status: status,
      };
    };

    const MyLocationsPage = connect(mapLocationsStateToProps)(LocationsPage);

    ReactDOM.render(
      <Provider store={store}>
        <MyLocationsPage />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  financesIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "index";

    if (path.startsWith("/finances/transactions")) view = "transactions";
    if (path.startsWith("/finances/sales_billings")) view = "sales_billings";
    if (path.startsWith("/finances/payment_accounts")) view = "payment_accounts";
    if (path.startsWith("/finances/insurances")) view = "insurances";
    if (path.startsWith("/finances/admin_transactions")) view = "admin_transactions";

    const mapFinancesStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbFinancesPage = connect(mapFinancesStateToProps)(FinancesPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbFinancesPage />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  statisticsIndex() {
    this.onBeforeRenderComponent();

    // Highlighting the bar
    let mainMenu = document.getElementById("inb-main-menu");
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector(".l-statistics")) {
      if (mainMenu.querySelector(".active") != null)
        mainMenu.querySelector(".active").classList.remove("active");
      mainMenu.querySelector(".l-statistics").classList.add("active");
    }

    // get view to render
    const path = document.location.pathname;
    let view = "charts";

    if (path.startsWith("/statistics/charts")) view = "charts";
    else if (path.startsWith("/statistics/heatmap")) view = "heatmap";

    const InbStatisticPage = connect((props) => ({ ...props, view }))(StatisticsPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbStatisticPage />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  reservationsIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "reservations";
    let addOrder = false,
      orderId = null,
      editOrder = false;
    if (path.startsWith("/reservations/reservationsList")) view = "reservations";
    if (path.startsWith("/reservations/orders")) view = "orders";
    if (path.startsWith("/reservations/calendar")) view = "calendar";
    let pathParams = null;
    let p;
    switch (view) {
      case "reservations":
        p = path.split("/reservations/reservationsList");
        if (p.length > 1) {
          pathParams = p[1].split("/");
          console.log(pathParams);
          if (containsNumbers(pathParams[1])) {
            orderId = pathParams[1];
            editOrder = true;
          } else if (pathParams[1] === "add") {
            addOrder = true;
          }
        }
        break;
    }
    let params = null;
    let states = {
      orderEdit: editOrder,
      orderAdd: addOrder,
      orderId: orderId,
    };
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapReservationsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbReservationsPage = connect(mapReservationsStateToProps)(ReservationsPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbReservationsPage params={params} states={states} />
      </Provider>,
      document.querySelector(this.el),
    );

    let mainMenu = document.getElementById("inb-main-menu");
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector(".l-orders")) {
      if (mainMenu.querySelector(".active") != null)
        mainMenu.querySelector(".active").classList.remove("active");
      mainMenu.querySelector(".l-orders").classList.add("active");
    }
  },

  resourcesIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "index";

    if (path.startsWith("/resources")) view = "resources";
    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapResourcesStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbResourcesPage = connect(mapResourcesStateToProps)(ResourcesPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbResourcesPage params={params} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );

    let mainMenu = document.getElementById("inb-main-menu");
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector(".l-resources")) {
      if (mainMenu.querySelector(".active") != null)
        mainMenu.querySelector(".active").classList.remove("active");
      mainMenu.querySelector(".l-resources").classList.add("active");
    }
  },

  contingentsIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "index";

    if (path.startsWith("/contingents")) view = "contingents";
    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }
    let accessBar = document.getElementById("inb-c-main-access-bar");
    let createAccessBar = false;

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    } else {
      createAccessBar = true;
    }

    const mapContingentsStateToProps = () => {
      return {
        createAccessBar: createAccessBar,
        view: view,
      };
    };
    const InbContingentsPage = connect(mapContingentsStateToProps)(ContingentsPage);
    ReactDOM.render(
      <Provider store={store}>
        <InbContingentsPage params={params} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );

    let mainMenu = document.getElementById("inb-main-menu");
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector(".l-contingents")) {
      if (mainMenu.querySelector(".active") != null)
        mainMenu.querySelector(".active").classList.remove("active");
      mainMenu.querySelector(".l-contingents").classList.add("active");
    }

    if (accessBar) {
      accessBar = document
        .getElementById("inb-c-main")
        .insertAdjacentElement("afterbegin", accessBar);
      if (accessBar.querySelector(".active") != null)
        accessBar.querySelector(".active").classList.remove("active");
      accessBar.querySelector('li[data-inb-val="contingents"]').classList.add("active");
    }
  },

  /* contingentPlansIndex(uriParams = null)
    {
        this.onBeforeRenderComponent();

        // get view to render
        const path = document.location.pathname;
        let view = 'index';

        if (path.startsWith('/contingent_plans')) view = 'contingent_plans';
        let params = null;
        if (uriParams) {
            params = uriParams.split('=');
        }
        let accessBar = document.getElementById('inb-c-main-access-bar');
        let createAccessBar = false;

        if (accessBar) {
            accessBar = accessBar.cloneNode(true);
        } else {
            createAccessBar = true;
        }
        const mapContingentPlansStateToProps = (state) => {
                return {
                    createAccessBar: createAccessBar,
                    view: view
                }
            };
        const InbContingentPlansPage = connect(mapContingentPlansStateToProps)(ContingentPlansPage);
        ReactDOM.render(
                <Provider store={store}>
                    <InbContingentPlansPage params={params} returnPath={Uri.getUrlParameter('path')}/>
                </Provider>,
                document.querySelector(this.el)
        );

        let mainMenu = document.getElementById('inb-main-menu');
        if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-contingent_plans')) {
                if (mainMenu.querySelector('.active') != null) mainMenu.querySelector('.active').classList.remove('active');
                mainMenu.querySelector('.l-contingents').classList.add('active');
        }

        if (accessBar) {
            accessBar = document.getElementById('inb-c-main').insertAdjacentElement('afterbegin',accessBar);
            if(accessBar.querySelector('.active') != null) accessBar.querySelector('.active').classList.remove('active');
            accessBar.querySelector('li[data-inb-val="contingent_plans"]').classList.add('active');
        }
    },*/

  errorsIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "index";

    if (path.startsWith("/errors")) view = "errors";
    if (path.startsWith("/apperrors")) view = "apperrors";
    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapErrorsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbErrorsPage = connect(mapErrorsStateToProps)(ErrorsPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbErrorsPage params={params} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  clientSettingsIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    let view = "settings";

    //if (path.startsWith('/settings')) view = 'settings';
    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapSettingsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbSettingsPage = connect(mapSettingsStateToProps)(SettingsPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbSettingsPage params={params} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  myInbooma(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    let view = "settings";

    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapSettingsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbInboomaPage = connect(mapSettingsStateToProps)(MyInboomaPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbInboomaPage params={params} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  visualInspectionsIndex() {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "index";
    let pathParams = null;
    let p = path.split("/visual_inspections/");
    if (p.length > 1) {
      pathParams = p[1].split("/");
    }

    const mapSettingsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbVisualInspectionsPage = connect(mapSettingsStateToProps)(VisualInspectionsPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbVisualInspectionsPage params={pathParams} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  vouchersIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "vouchers";
    let add = path.includes("/add");

    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapSettingsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbVouchersPage = connect(mapSettingsStateToProps)(VouchersPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbVouchersPage params={params} returnPath={Uri.getUrlParameter("path")} add={add} />
      </Provider>,
      document.querySelector(this.el),
    );
    let mainMenu = document.getElementById("inb-main-menu");
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector(".l-vouchers")) {
      if (mainMenu.querySelector(".active") != null)
        mainMenu.querySelector(".active").classList.remove("active");
      mainMenu.querySelector(".l-vouchers").classList.add("active");
    }
  },

  availabilitiesIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "availabilities";

    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapSettingsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbAvailabilitiesPage = connect(mapSettingsStateToProps)(AvailabilitiesPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbAvailabilitiesPage params={params} returnPath={path} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  helpDeskIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "helpdesk";

    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapSettingsStateToProps = (state) => {
      return {
        view: view,
      };
    };

    const InbHelpDeskPage = connect(mapSettingsStateToProps)(HelpdeskPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbHelpDeskPage params={params} returnPath={path} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  invoicesIndex(uriParams = null) {
    console.log("Routing ok");
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "invoices";

    let params = null;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapSettingsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbInvoicesPage = connect(mapSettingsStateToProps)(InvoicesPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbInvoicesPage params={params} returnPath={path} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  abonnementsIndex(uriParams = null) {
    this.onBeforeRenderComponent();
    // Clone and append accessBar (which would be out of scope of this controller)
    let accessBar = document.getElementById("inb-c-main-access-bar");
    let createAccessBar = false;

    if (accessBar) {
      accessBar = accessBar.cloneNode(true);
    } else {
      createAccessBar = true;
    }
    // get view to render
    const path = document.location.pathname;
    let view = "abonnements";
    let add = false,
      index = null,
      edit = false;
    if (path.startsWith("/abonnementsUsers")) view = "abonnementsUsers";
    if (path.startsWith("/abonnements")) view = "abonnements";
    if (path.startsWith("/abonnements/add")) add = true;
    let pathParams = null;
    let p;
    switch (view) {
      case "abonnements":
        p = path.split("/abonnements/");
        if (p.length > 1) {
          pathParams = p[1].split("/");
          if (containsNumbers(pathParams[0])) {
            index = pathParams[0];
            edit = true;
          }
        }
        break;
      case "abonnementsUsers":
        p = path.split("/abonnementsUsers/");
        if (p.length > 1) {
          pathParams = p[1].split("/");
          if (containsNumbers(pathParams[0])) {
            index = pathParams[0];
            edit = true;
          }
        }
        break;
    }
    let params = null;
    let states = {
      edit: edit,
      add: add,
      index: index,
    };
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapAbonnementsStateToProps = () => {
      return {
        createAccessBar: createAccessBar,
        view: view,
      };
    };

    const InbAbonnementsPage = connect(mapAbonnementsStateToProps)(AbonnementsPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbAbonnementsPage params={params} returnPath={path} states={states} />
      </Provider>,
      document.querySelector(this.el),
    );

    if (accessBar) {
      accessBar = document
        .getElementById("inb-c-main")
        .insertAdjacentElement("afterbegin", accessBar);
      if (accessBar.querySelector(".active") != null)
        accessBar.querySelector(".active").classList.remove("active");
      accessBar.querySelector('li[data-inb-val="abonnements"]').classList.add("active");
    }
  },

  clientDocumentsIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "index";
    let pathParams = null;
    let p = path.split("/client_docs/");
    if (p.length > 1) {
      pathParams = p[1].split("/");
    }
    const mapSettingsStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbClientDocumentsPage = connect(mapSettingsStateToProps)(ClientDocumentsPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbClientDocumentsPage params={pathParams} returnPath={Uri.getUrlParameter("path")} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  helpMessagesIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "helpMessages";
    let addHelpMessage = false,
      addHelpMessageItem = false,
      helpMessageId = null,
      editHelpMessage = false,
      editHelpMessageItem = false,
      helpMessageItemId = null;
    if (path.startsWith("/help_messages")) view = "helpMessages";
    if (path.startsWith("/help_messages/add")) addHelpMessage = true;
    let pathParams = null;
    let p;
    switch (view) {
      case "helpMessages":
        p = path.split("/help_messages/");
        if (p.length > 1) {
          pathParams = p[1].split("/");
          if (containsNumbers(pathParams[0])) {
            helpMessageId = pathParams[0];
            editHelpMessage = true;
            if (containsNumbers(pathParams[1])) {
              helpMessageItemId = pathParams[1];
              editHelpMessage = false;
              editHelpMessageItem = true;
            } else if (pathParams[1] === "add") {
              editHelpMessage = false;
              addHelpMessageItem = true;
            }
          } else if (pathParams[0] === "add") {
            addHelpMessage = true;
          }
        }
        break;
    }
    let params = null;
    let states = {
      helpMessageEdit: editHelpMessage,
      helpMessageAdd: addHelpMessage,
      helpMessageId: helpMessageId,
      helpMessageItemEdit: editHelpMessageItem,
      helpMessageItemAdd: addHelpMessageItem,
      helpMessageItemId: helpMessageItemId,
    };
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapHelpMessagesStateToProps = () => {
      return {
        view: view,
      };
    };

    const InbHelpMessagesPage = connect(mapHelpMessagesStateToProps)(HelpMessagesPage);

    ReactDOM.render(
      <Provider store={store}>
        <InbHelpMessagesPage params={params} returnPath={path} states={states} />
      </Provider>,
      document.querySelector(this.el),
    );
  },

  reportsIndex(uriParams = null) {
    this.onBeforeRenderComponent();

    // get view to render
    const path = document.location.pathname;
    let view = "reports";
    let add = false;
    if (path.startsWith("/reports")) view = "reports";
    if (path.startsWith("/reports/add")) add = true;
    let params;
    if (uriParams) {
      params = uriParams.split("=");
    }

    const mapReportsPagesStateToProps = () => {
      return {
        view: view,
      };
    };

    const ReportsPages = connect(mapReportsPagesStateToProps)(ReportsPage);

    ReactDOM.render(
      <Provider store={store}>
        <ReportsPages params={params} returnPath={path} add={add} />
      </Provider>,
      document.querySelector(this.el),
    );
  },
});
